/** @format */

import SurveyListItem from "./SurveyListItem";

const SurveyList = ({ list }) =>
  list.map(({ title, status, ...rest }, index) => (
    <SurveyListItem key={rest.surveyId} title={title} status={status} index={index} {...rest} />
  ));

export default SurveyList;
